import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7d2ccc9e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "footer-bar"
};
const _hoisted_2 = {
  class: "footer-item"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Copyright2019瑞特支付（福建）有限公司.All Rights Reserved.", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "10px"
  }
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "item",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.routePath('product', 'constitution'))
  }, "预付卡章程"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.routePath('product', 'agreement'))
  }, "购卡协议"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.routePath('index'))
  }, "关于我们"), _createElementVNode("div", {
    class: "item",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.routePath('contact'))
  }, "联系我们")]), _hoisted_3, _hoisted_4, _createElementVNode("div", {
    class: "IPC",
    onClick: _cache[4] || (_cache[4] = (...args) => _ctx.urlRoute && _ctx.urlRoute(...args))
  }, "ICP经营许可证编号闽ICP备10204263号")]);
}